/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'magnifier-3': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data:
      '<g fill-rule="evenodd" clip-rule="evenodd" _fill="#fff"><path pid="0" d="M7.614 1.831a5.783 5.783 0 104 9.96.776.776 0 01.177-.176A5.783 5.783 0 007.615 1.83zm5.697 10.39a7.325 7.325 0 10-1.09 1.09l2.174 2.174a.771.771 0 001.09-1.09l-2.174-2.175z"/><path pid="1" d="M0 7.614a7.614 7.614 0 1113.696 4.583l1.994 1.993a1.06 1.06 0 01-1.5 1.5l-1.993-1.994A7.614 7.614 0 010 7.614zM7.614.578a7.036 7.036 0 104.425 12.508.29.29 0 01.386.02l2.174 2.175a.482.482 0 10.681-.682l-2.174-2.174a.29.29 0 01-.02-.387A7.036 7.036 0 007.614.578zm0 1.542a5.494 5.494 0 103.784 9.478 1.073 1.073 0 01.2-.2A5.494 5.494 0 007.614 2.12zM1.542 7.614A6.072 6.072 0 1112 11.814a.289.289 0 01-.04.035.487.487 0 00-.11.11.296.296 0 01-.034.04A6.072 6.072 0 011.542 7.614z"/></g>'
  }
})
